import {observable, autorun, computed} from 'mobx';
import * as LoadLevel from './LoadLevel';
import JobType from './JobType';

// Move attributes from db record to typed object
function createCustomerFromDBRow(row) {
  // console.log("createCustomerFromDBRow",row);
  var c = new Customer();
  c.name=row.name;
  c.id=row.id;
  c.id_account = row.id_account;
  c.country_code = row.country_code;
  c.language = row.language;
  c.segment = row.segment;
  if(row.job_types) {
    c.job_types = row.job_types.map(JobType.createFromDBRow);
  }
  c.id_distributor=row.id_distributor;
  c.is_distributor=row.is_distributor;
  c.additional_sms_recipients=row.additional_sms_recipients;
  // sconsole.log(toJS(c));
  return c;
}

class Customer {
  @observable id;
  @observable name;
  @observable users;
  @observable machines;
  @observable beacons;
  @observable loadingBeacons;
  @observable loadingUsers;
  @observable loadingMachines;
  @observable deleted;
  @observable id_account;
  @observable country_code;
  @observable segment;
  @observable job_types;
  // When registering a new customer, we look up the customer id while
  // the user is typing to avoid triggering DB error later:
  @observable id_checked;
  @observable id_unique;
  @observable language='EN';

  @observable id_distributor;
  @observable is_distributor;

   // Way of seperating the customerform from userform
   @observable is_customer = true;
   @observable additional_sms_recipients;
  constructor() {
    this.reset();
  }

  reset() {
    this.id=null;
    this.name=null;
    this.users=[];
    this.machines=[];
    this.beacons=[];
    this.loadingBeacons=false;
    this.deleted=false;
    this.loadingUsers=false;
    this.loadingMachines=false;
    this.id_account=null;
    this.country_code=null;
    this.segment=null;
    this.job_types=[];
    this.id_checked=null;
    this.id_unique=false;
    this.language='EN';
    this.id_distributor=null;
    this.is_distributor=false;
    this.is_customer=true;
    this.additional_sms_recipients=null;
  }

  @computed get idChecked() {
    return this.id_checked==this.id;
  }

  @computed get idCheckedAndOK() {
    return this.id_checked==this.id && this.id_unique;
  }

  hasJobType(jobType) {
    return this.job_types.findIndex( jt => jt.id == jobType.id)!=-1;
  }

  getJobType(jobType) {
    return this.job_types.find( jt => jt.id == jobType.id);
  }

  toggleJobType(jobType) {
    if(!this.hasJobType(jobType)) {
      let njt = jobType.clone();
      njt.priority = this.job_types.length+1;
      this.job_types.push(njt);
    }
    else {
      let newTypes=this.job_types.filter(jt => jt.id!=jobType.id);
      // Sort them by priority
      newTypes.sort((a, b) => a.priority - b.priority);
      let priority = 1;
      // and re-enumerate the remaining priorities
      newTypes.forEach( nt => {nt.priority=priority++});
      this.job_types = newTypes;
    }
  }

  updateFrom(otherCustomer) {
    // console.log("updateFrom",toJS(otherCustomer))
    this.id = otherCustomer.id;
    this.name = otherCustomer.name;
    this.id_account = otherCustomer.id_account;
    this.country_code = otherCustomer.country_code;
    this.language = otherCustomer.language;
    this.segment = otherCustomer.segment;
    if(otherCustomer.job_types) {
      this.job_types = [...otherCustomer.job_types];
    }
    this.id_distributor = otherCustomer.id_distributor;
    this.is_distributor = otherCustomer.is_distributor;
    this.additional_sms_recipients = otherCustomer.additional_sms_recipients;
  }

  // If the data in this object seems to validate sufficiently for a new
  // customer registration
  @computed get valid_as_new() {
    if(!this.id) return false;
    if(!this.name) return false;
    if(!this.idCheckedAndOK) return false;
    return true;
  }
}

// Make utility method available from Class (function)
Customer.createFromDBRow=createCustomerFromDBRow;

export default Customer;



/** WEBPACK FOOTER **
 ** ./src/DataModel/Customer.js
 **/